import { COUNTRY_CODE_LIST } from '../../internationalization/const'

export const renderCountryName = (countryCode) => {
    const country = COUNTRY_CODE_LIST.find(item => item.id === countryCode)
    return country ? country.value : ''
}



// WEBPACK FOOTER //
// ./src/modules/partner/util/names.js